import React from 'react';
import './home.css';


function Home() {
  return <div className="home_container" id="home">
   <div className="home_background">
   </div>
   <div className="home_content_container"> 
             <h1 className='home_text_fade home_content_heading'>Best Land Promoters In Theni District</h1>
           <hr style={{height:'3px',color:'white'}}/> 
           <p  className="home_content_description">
           <span className="home_text_fade">We  are </span>
           <span className="home_text_fade">Provide </span>
           <span className="home_text_fade">Best </span>
           <span className="home_text_fade">Approval </span>
           <span className="home_text_fade">Plots, </span>
           <span className="home_text_fade">And Home Loan</span>
             <span className="home_text_fade">Services </span>
             <span className="home_text_fade">For </span>
             <span className="home_text_fade">Your dream </span>
             <span className="home_text_fade">House. </span>
             <span className="home_text_fade">And also</span>
             <span className="home_text_fade">we are providing</span>
             <span className="home_text_fade">construction plans</span>
             <span className="home_text_fade"> And solutions for you.</span>
             <span className="home_text_fade">Contact</span>
             <span className="home_text_fade">Us</span>
             <span className="home_text_fade">for more details.</span>  
             </p>
          <div>
             <button className='home_contact_button  home_text_fade' onClick={() => window.open("/contact-us","_self")}>contact us</button>
            </div>
     </div>
        
  </div>;
}

export default Home;
